import { gql } from '@apollo/client';

const fdaPracticeAreaFragment = gql`
  fragment FdaPracticeAreaFragment on FdaPracticeArea {
    Acronym
    Name
    Trend
    Practice {
      Name
    }
    GroupLevel
    NumberWithinLevel
    SatisfiedPercentage
    AggregatePercentage
    Count
  }
`;

export default fdaPracticeAreaFragment;
